<template>
  <div id="resumme-work-history" class="col-12 bg-white-primary mx-auto">
    <div
      class="d-flex flex-column flex-md-row justify-content-md-start align-items-center mb-3 mx-0 ps-0 ps-md-3 pe-0"
    >
      <div class="size-16 fw-bold text-center ps-0 ps-md-2">経験企業</div>
      <span class="tag-thirdly size-10 ms-2 mb-4 mb-md-0">必須</span>
    </div>
    <div class="row mx-0 pt-4 gap-3 border-top">
      <div class="col-12 col-md-4 px-4">
        <Field
          v-slot="{ field, errors }"
          v-model="workHistoryStore.experienced_companies_number"
          name="experienced_companies_number"
        >
          <div
            class="d-flex pe-0 justify-content-between justify-content-md-start align-items-center mb-1"
          >
            <label class="size-12" for="">経験企業数</label>
          </div>
          <select
            class="form-select select-input-primary size-14 p-0d8"
            v-bind="field"
            :class="{ 'is-invalid': !!errors.length }"
          >
            <option value="" disabled selected>選択してください</option>
            <option v-for="year in getListNumber(1, 50)" :key="year" :value="year">
              {{ year }}
            </option>
          </select>
          <ErrorMessage name="experienced_companies_number" class="invalid-feedback" />
        </Field>
      </div>
      <div class="col-12 border-0 border-md-top px-4 pt-md-3">
        <Field
          v-slot="{ field, errors }"
          v-model="workHistoryStore.corporation_name"
          name="corporation_name"
        >
          <div
            class="d-flex pe-0 justify-content-between justify-content-md-start align-items-center mb-1"
          >
            <label class="size-12" for="">直近の在籍企業</label>
            <span class="tag-thirdly size-10 ms-2">必須</span>
          </div>
          <input
            type="text"
            placeholder="会社名"
            class="p-0d8 input-primary form-control bg-silver-primary size-14 border-0"
            v-bind="field"
            :class="{ 'is-invalid': !!errors.length }"
          />
          <div
            class="d-flex justify-content-end mt- size-10"
            :class="
              workHistoryStore.corporation_name?.length > 100 ? 'text-danger' : 'text-black-50'
            "
          >
            {{ workHistoryStore.corporation_name?.length || 0 }}
            /100（最大文字数100文字）
          </div>
          <ErrorMessage name="corporation_name" class="invalid-feedback" />
          <div class="mt-2 text-black-50 size-12">
            <span>※フリーランス/自営業の経験の方は、その旨を入力してください。</span>
          </div>
        </Field>
      </div>
      <div class="d-flex flex-column flex-md-row border-0 border-md-top ps-4 pt-md-3 gap-3 h-auto">
        <div class="col-md-8 d-flex flex-column flex-md-row gap-3">
          <div class="input-group row pe-0 pe-md-3 align-items-start flex-column">
            <div class="form-label d-flex align-items-center">
              <label class="size-12" for="">入社年月</label>
              <span class="tag-thirdly size-10 ms-2">必須</span>
            </div>
            <div class="d-flex gap-3 gap-md-2">
              <div class="col-6 pe-0">
                <Field
                  v-slot="{ field, errors }"
                  v-model="workHistoryStore.from_year"
                  name="from_year"
                >
                  <select
                    class="form-select select-input-primary size-14 p-0d8"
                    :class="{ 'is-invalid': !!errors.length }"
                    v-bind="field"
                  >
                    <option value="" disabled selected>年</option>
                    <option v-for="e in getListNumber(1970, currentYear)" :key="e" :value="e">
                      {{ e }}
                    </option>
                  </select>
                  <ErrorMessage name="from_year" class="invalid-feedback" />
                </Field>
              </div>

              <div class="col-6 pe-0">
                <Field
                  v-slot="{ field, errors }"
                  v-model="workHistoryStore.from_month"
                  name="from_month"
                >
                  <select
                    class="form-select select-input-primary size-14 p-0d8"
                    :class="{ 'is-invalid': !!errors.length }"
                    v-bind="field"
                  >
                    <option value="" disabled selected>月</option>
                    <option v-for="e in getListNumber(1, 12)" :key="e" :value="e">
                      {{ e }}
                    </option>
                  </select>
                  <ErrorMessage name="from_month" class="invalid-feedback" />
                </Field>
              </div>
            </div>
          </div>

          <div
            v-if="!workHistoryStore.is_enrolled"
            class="input-group row pe-0 pe-md-3 align-items-start flex-column"
          >
            <div class="form-label d-flex align-items-center">
              <label class="size-12" for="">退社年月</label>
            </div>
            <div class="d-flex gap-3 gap-md-2">
              <div class="col-6 pe-0">
                <Field v-slot="{ field, errors }" v-model="workHistoryStore.to_year" name="to_year">
                  <select
                    class="form-select select-input-primary size-14 p-0d8"
                    :class="{ 'is-invalid': !!errors.length }"
                    v-bind="field"
                  >
                    <option value="" disabled selected>年</option>
                    <option v-for="e in getListNumber(1970, currentYear)" :key="e" :value="e">
                      {{ e }}
                    </option>
                  </select>
                  <ErrorMessage name="to_year" class="invalid-feedback" />
                </Field>
              </div>

              <div class="col-6 pe-0">
                <Field
                  v-slot="{ field, errors }"
                  v-model="workHistoryStore.to_month"
                  name="to_month"
                >
                  <select
                    class="form-select select-input-primary size-14 p-0d8"
                    v-bind="field"
                    :class="{ 'is-invalid': !!errors.length }"
                  >
                    <option value="" disabled selected>月</option>
                    <option v-for="e in getListNumber(1, 12)" :key="e" :value="e">
                      {{ e }}
                    </option>
                  </select>
                  <ErrorMessage name="to_month" class="invalid-feedback" />
                </Field>
              </div>
            </div>
          </div>
          <div class="input-group row pe-0 pe-md-3">
            <div class="col-12 pe-0 d-flex align-items-start">
              <Field v-slot="{ field }" name="is_enrolled">
                <div
                  class="bg-silver-primary p-2 d-flex align-items-center mt-md-30x p-0d8 p-md-0d5 rounded-3 w-100"
                >
                  <input
                    id="is_enrolled"
                    v-bind="field"
                    v-model="workHistoryStore.is_enrolled"
                    class="input-primary form-check-input checkbox-primary-input w-1d5 h-1d5"
                    type="checkbox"
                    :value="true"
                  />
                  <label class="form-label mb-0 ps-2 size-12" for="is_enrolled">在籍中</label>
                </div>
              </Field>
              <ErrorMessage name="is_enrolled" class="invalid-feedback" />
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="input-group row pe-0 pe-md-3">
            <div class="col-12 pe-0">
              <Field
                v-slot="{ field, errors }"
                v-model="workHistoryStore.employment_type_id"
                name="employment_type_id"
              >
                <div class="form-label d-flex align-items-center">
                  <label class="size-12" for="">雇用形態</label>
                  <span class="tag-thirdly size-10 ms-2">必須</span>
                </div>
                <select
                  class="form-select select-input-primary size-14 p-0d8"
                  :class="{ 'is-invalid': !!errors.length }"
                  v-bind="field"
                >
                  <option value="" disabled selected>選択してください</option>
                  <option
                    v-for="employmentType in employmentTypes"
                    :key="employmentType.id"
                    :value="employmentType.id"
                  >
                    {{ employmentType.name }}
                  </option>
                </select>
                <ErrorMessage name="employment_type_id" class="invalid-feedback" />
              </Field>
            </div>
          </div>
        </div>
      </div>
      <HistoryExperience :employment-types="employmentTypes" />
    </div>
    <div class="col-12 bg-white-primary mx-auto">
      <div class="border-bottom"></div>
      <div class="row mx-3 py-4">
        <div class="input-group row">
          <div class="col-12 pe-0">
            <label class="form-label size-12" for="">その他備考</label>
            <Field
              v-slot="{ field, errors }"
              v-model="workHistoryStore.experienced_companies_remarks"
              name="experienced_companies_remarks"
            >
              <textarea
                v-bind="field"
                :class="{ 'is-invalid': !!errors.length }"
                class="form-control bg-silver-primary input-primary size-14 border-0"
                rows="5"
                placeholder="経験企業が11社以上ある場合はこちらに記載してください。"
              ></textarea>
              <div
                class="d-flex justify-content-end mt-2 size-10"
                :class="
                  workHistoryStore.experienced_companies_remarks?.length > 2000
                    ? 'text-danger'
                    : 'text-black-50'
                "
              >
                {{ workHistoryStore.experienced_companies_remarks?.length || 0 }}
                /2000（最大文字数2000文字）
              </div>
              <ErrorMessage name="experienced_companies_remarks" class="invalid-feedback" />
            </Field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useWorkHistoryStore } from '@/stores/resume-candidate/WorkHistory.store';
import { EmploymentTypePrimary } from '@/types/models/employmentType';
import getListNumber from '@/utils/getListNumber';
import { getEmploymentTypes } from '@/apis/candidate';
import { Field, ErrorMessage } from 'vee-validate';
import HistoryExperience from './HistoryExperience.vue';

const currentYear = new Date().getFullYear();
const workHistoryStore = useWorkHistoryStore();
const employmentTypes = ref<EmploymentTypePrimary[]>([]);

onMounted(() => {
  getEmploymentTypesData();
});

const getEmploymentTypesData = async (): Promise<void> => {
  const res = await getEmploymentTypes(false);
  if (res.status === 200) {
    employmentTypes.value = res.data;
  }
};
</script>
